import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import MovingBoxShippingPage from '@/v2/components/pages/public-pages/moving-box-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/moving-box-shipping-page'

interface MovingBoxShippingPageProps {}

const Page: React.FC<MovingBoxShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.moving_box_shipping.title ?? ''}
        keywords={META_CONTENTS.moving_box_shipping?.keywords ?? ''}
        description={META_CONTENTS.moving_box_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <MovingBoxShippingPage />
    </>
  )
}

export default Page
